import { mapActions } from 'vuex';
import EventBus from '../modules/EventBus';
import BnForgalmiBetukod from '../components/basecomponents/BnForgalmiBetukod.vue';

export default {
    components: {
        BnForgalmiBetukod
    },

    data() {
        return {
            visibility: false,
            editable: true,
            path: null,
        };
    },

    props: {
        attributes: {
            type: Object,
            required: true,
        },
    },

    mounted() {
        this.$nextTick(() => {
            EventBus.$on('disable-fields', () => {
                this.editable = false;
            });
            if (this.$refs[this.attributes.mezo]) {
                this.$refs[this.attributes.mezo].keyboardLookupPrefix = '';
            }

            if (this.attributes.textTransform && !!this.inputVal) {
                this.inputVal = this.attributes.textTransform(this.inputVal);
            }
            this.tabSkipClearIcon();
        });
    },

    watch: {
        getErrors() {
            const errors = this.$store.getters.getErrors;
            if (this.attributes.mezo in errors) {
                let error = [];
                if (errors[this.attributes.mezo]) {
                    error = [errors[this.attributes.mezo]
                        .replace(/ \(.*\)/, '') // zárójel és a benne lévő adatok törlése
                        .replace(/Érvénytelen boolean érték/, 'A mező kitöltése kötelező')];
                } else {
                    throw new Error('Something went wrong with the error messages.');
                }
                if (!error.includes('Értékvizsgálathoz szükséges adat nincs megadva!')) {
                    this.$refs[this.attributes.mezo].validate(true);
                    if (this.attributes.type === 'date') {
                        this.$refs[this.attributes.mezo].setErrorBucket(error);
                    } else {
                        this.$refs[this.attributes.mezo].errorBucket = error;
                    }
                }
            }
        },
        isVisible(val) {
            this.visibility = val;
        },
    },

    created() {
        if (this.attributes && this.attributes.resource) {
            this.fetchInputResource();
        }
        this.visibility = this.attributes.visible;
    },

    methods: {
        ...mapActions([
            'updateHelp',
        ]),
        isVisible() {
            return typeof this.attributes.visible === 'function'
                ? this.attributes.visible()
                : this.attributes.visible;
        },
        getStyle() {
            return !this.attributes.editable
                ? 'background: rgb(240, 238, 238); padding-right:5px;padding-left:5px;'
                : '';
        },

        isEditable() {
            return this.attributes.editable && this.editable;
        },

        onKeyPress(e) {
            if (this.attributes.type === 'select') {
                const KEYBOARD_LOOKUP_THRESHOLD = 1000;
                const now = performance.now();
                if (now - this.$refs[this.attributes.mezo].keyboardLookupLastTime > KEYBOARD_LOOKUP_THRESHOLD) {
                    this.$refs[this.attributes.mezo].keyboardLookupPrefix = '';
                }

                this.$refs[this.attributes.mezo].keyboardLookupPrefix += e.key.toLowerCase();
                this.$refs[this.attributes.mezo].keyboardLookupLastTime = now;

                const index = this.$refs[this.attributes.mezo].allItems.findIndex((item) => {
                    const text = (this.$refs[this.attributes.mezo].getText(item) || '').toString();
                    return text.toLowerCase()
                        .startsWith(this.$refs[this.attributes.mezo].keyboardLookupPrefix);
                });

                if (index !== -1) {
                    setTimeout(() => this.$refs[this.attributes.mezo].setMenuIndex(index));
                }
            }
        },

        keyDownFn() {
            // this.onKeyPress(event);
        },
        clearFn() {
            if (this.attributes.type === 'text') {
                this.inputVal = '';
            }
        },

        focus() {
            if (Object.prototype.hasOwnProperty.call(this.attributes, 'focus')) {
                this.attributes.focus();
            }
            this.$store.commit('setMezo', this.attributes.mezo);
            this.updateHelp();
        },

        fetchInputResource() {
            this.$store.dispatch('getList', this.attributes.resource);
        },

        blurFn() {
            if (Object.prototype.hasOwnProperty.call(this.attributes, 'blur')
                && this.attributes.type !== 'date') {
                this.attributes.blur();
            }
            if (typeof this.inputVal === 'string') {
                // this.inputVal = this.inputVal.trim();
            }
        },
        tabSkipClearIcon() {
            const elements = document.getElementsByClassName('mdi-close');

            for (let i = 0; i < elements.length; i += 1) {
                elements[i].setAttribute('tabindex', '-1');
            }
        },

        changeFn(event) {
            this.tabSkipClearIcon();
            if (Object.prototype.hasOwnProperty.call(this.attributes, 'change')) {
                this.attributes.change(event);
            }
        },

        onKeyUp() {
            if (this.attributes.textTransform && !!this.inputVal) {
                this.inputVal = this.attributes.textTransform(this.inputVal);
            }
        },
    },

    computed: {

        hideLabel() {
            return this.attributes.hideLabel || this.attributes.separateLabel;
        },

        forgalmiBetukodStyle() {
            return 'background: var(--v-secondaryButtonColor-base);';
        },

        labelStyles() {
            if (!this.isEditable()) {
                return { color: 'rgba(0,0,0,.38)' };
            }
            return undefined;
        },

        getClass() {
            if (this.cfg.props.oneColumn) {
                return 'md12 xs12';
            }
            return this.attributes.width ? this.attributes.width : 'md6 xs12';
        },

        getErrors() {
            return this.$store.getters.getErrors;
        },

        getPersistentHint() {
            return this.attributes.required ? 'Kötelező mező' : (this.attributes.hint || '');
        },

        getOptions() {
            return this.attributes.resource ? this.getOptionsByResourse : this.attributes.options;
        },

        getOptionsByResourse() {
            return this.$store.getters.lists[this.attributes.resource];
        },

        getClearable() {
            return this.attributes.clearable != null ? this.attributes.clearable : this.getInputType !== 'v-text-field';
        },

        getInputType() {
            switch (this.attributes.type) {
            case 'text': {
                return 'v-text-field';
            }
            case 'textbox': {
                return 'v-text-field';
            }
            case 'textarea': {
                return 'v-textarea';
            }
            case 'select': {
                return 'v-select';
            }
            case 'dropdownlist': {
                return 'v-select';
            }
            case 'combobox': {
                return 'v-combobox';
            }
            case 'checkbox': {
                return 'v-checkbox';
            }
            case 'autocomplete': {
                return 'v-autocomplete';
            }
            case 'date': {
                return 'BnDate';
            }
            case 'caption': {
                return 'span';
            }
            default:
                throw new Error('bnFormField input type not implemented yet');
            }
        },
    },
};
